<template>
	<div class="email-font-picker-select">
		<v-select
				class="__select small"
				:options="options"
				@change="fontChange"
				@input="fontChange"
				:value="value"
				label="label"
				placeholder="Default font"
				searchable
				clearable
				:reduce="item => item.id"
				append-to-body>
			<template v-slot:option="option">
				<span :style="{fontFamily: option.label}">
					{{option.label}}
				</span>
			</template>
			<template v-slot:selected-option="option">
				<span :style="{fontFamily: option.label}">
					{{option.label}}
				</span>
			</template>
		</v-select>
	</div>
</template>

<script>
import SelectField from "@/components/base/select-field";
export default {
  name: 'FontPickerSelect', components: {SelectField},
	props: ['options', 'value'],
  data: function(){
    return {
    }
  },
  computed: {
  },
  methods: {
    fontChange(ev){
      this.$emit('change', ev);
    }
  },
}
</script>
<style lang="scss" scoped>
.email-font-picker-select {
	display: flex;
	flex: 1;
	flex-direction: row;

	.__select {
		width: 100%;
	}
}
</style>
<style lang="scss">
.email-font-picker-select {

}
</style>
